<div class="grid">
  <div class="col-12 xl:col-10 xl:col-offset-1">
    <div class="grid">
      <div class="col-12 xl:col-8 lg:col-12">
        @if (!loading && faqList) {
          <div class="grid">
            @for (faqSection of faqList.sections; track faqSection) {
              <div class="col-12">
                <p-card [header]="faqSection.title">
                  <div class="mt-3">
                    <p-accordion>
                      @for (faqItem of faqSection.items; track faqItem) {
                        <p-accordion-panel [value]="faqItem.id">
                          <p-accordion-header><span class="text-lg">{{ faqItem.question }}</span></p-accordion-header>
                          <p-accordion-content>
                            <div class="text-lg line-height-3" [innerHTML]="faqItem.answer | safeHtml"></div>
                          </p-accordion-content>
                        </p-accordion-panel>
                      }
                    </p-accordion>
                  </div>
                </p-card>
              </div>
            }
          </div>
        }
      </div>
      <div class="col-12 xl:col-4">
        <sps-support-info gradientStyleClass="sps-background"></sps-support-info>
      </div>
    </div>
  </div>
</div>
